var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-navigation-drawer",
    {
      class: _vm.cssClass,
      attrs: { clipped: "", temporary: "", app: "" },
      model: {
        value: _vm.$store.state.ui.navDrawerVisible,
        callback: function ($$v) {
          _vm.$set(_vm.$store.state.ui, "navDrawerVisible", $$v)
        },
        expression: "$store.state.ui.navDrawerVisible",
      },
    },
    [
      _c(
        "v-list",
        [
          _c(
            "v-list-item-group",
            {
              attrs: { mandatory: "" },
              model: {
                value: _vm.selectedItem,
                callback: function ($$v) {
                  _vm.selectedItem = $$v
                },
                expression: "selectedItem",
              },
            },
            _vm._l(_vm.$store.state.ui.navigationItems, function (item, index) {
              return _c("navigation-item", {
                key: index,
                ref: index,
                refInFor: true,
                attrs: { "navigation-item": item },
                on: { click: _vm.clicked },
              })
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }